import React from 'react';
import Form from './Form/Form';
import SearchBannerImage from './SearchBannerImage';
import InspirationData from '../helpers/InspirationDataHelper';

const theme = InspirationData.getTheme();
const imgUrl = InspirationData.getImgUrl();

const SearchBanner = () => {
  return (
    <section className={`crtSearchInspirationBanner has-theme-${theme}`}>
      <SearchBannerImage imgUrl={imgUrl} theme={theme} />
      <Form />
    </section>
  );
};

export default SearchBanner;
